import { defineMessages } from 'react-intl';

export const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nameFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jqlFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnsFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyColumnsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.card-title',
		defaultMessage: 'Update queue',
		description: 'Card title when updating a JSM queue without a known name',
	},
	nameFieldLabel: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.name-field-label',
		defaultMessage:
			'Update queue name from "<bold>{currentName}</bold>" to "<bold>{newName}</bold>"',
		description:
			'Label for the queue name field in the update queue card body. <bold> wraps the old and new names in bold.',
	},
	jqlFieldLabel: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.jql-field-label',
		defaultMessage: 'Update JQL queue filters',
		description: 'Label for the JQL filter field in the update queue card body',
	},
	columnsFieldLabel: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.columns-field-label',
		defaultMessage: 'Following are the updated the columns for this queue:',
		description: 'Label for the columns field in the update queue card body',
	},
	emptyColumnsDescription: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.empty-columns-description',
		defaultMessage:
			'This queue has no columns. Add columns to show your team how the queue is ordered.',
		description:
			'Message shown in the update queue card when no columns will be assigned to the queue.',
	},
	confirmButton: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.confirm-button',
		defaultMessage: 'Update',
		description: 'Label for the confirm button when updating a JSM queue',
	},
	expandBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.expand-body-content',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height',
	},
	collapseBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.collapse-body-content',
		defaultMessage: 'Show less',
		description:
			'Button label to collapse the card content area after it was expanded for long text',
	},
	successPill: {
		id: 'ai-mate.conversation-assistant-message-actions.update-queue.success-pill',
		defaultMessage: `You've updated "{name}"`,
		description: 'Pill message shown after update JSM queue succeeds. {name} is the queue name.',
	},
});
